import {environment} from '../../environments/environment.demo';

export const AMORIM_API = environment.api;

/**URL para acesso à API Asaas*/
export const API_CONVERSOR = environment.apiConversor;

/**Account Token para permissão de acesso à API Asaas */
export const accountAccessConversor = environment.accountAccessConversor;
